import { render, staticRenderFns } from "./RecoverPassForm.vue?vue&type=template&id=96aa9898&scoped=true&"
import script from "./RecoverPassForm.vue?vue&type=script&lang=js&"
export * from "./RecoverPassForm.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPassForm.vue?vue&type=style&index=0&id=96aa9898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96aa9898",
  null
  
)

export default component.exports